export enum CountryCodeEnum {
  AF = 'AF', // Afghanistan
  ZA = 'ZA', // Afrique du Sud
  AX = 'AX', // Åland
  AL = 'AL', // Albanie
  DZ = 'DZ', // Algérie
  DE = 'DE', // Allemagne
  AD = 'AD', // Andorre
  AO = 'AO', // Angola
  AI = 'AI', // Anguilla
  AQ = 'AQ', // Antarctique
  AG = 'AG', // Antigua-et-Barbuda
  AN = 'AN', // Antilles néerlandaises
  SA = 'SA', // Arabie saoudite
  AR = 'AR', // Argentine
  AM = 'AM', // Arménie
  AW = 'AW', // Aruba
  AC = 'AC', // Ascension
  AU = 'AU', // Australie
  AT = 'AT', // Autriche
  AZ = 'AZ', // Azerbaïdjan
  BS = 'BS', // Bahamas
  BH = 'BH', // Bahreïn
  BD = 'BD', // Bangladesh
  BB = 'BB', // Barbade
  BE = 'BE', // Belgique
  BZ = 'BZ', // Belize
  BJ = 'BJ', // Bénin
  BM = 'BM', // Bermudes
  BT = 'BT', // Bhoutan
  BY = 'BY', // Biélorussie
  BO = 'BO', // Bolivie
  BA = 'BA', // Bosnie-Herzégovine
  BW = 'BW', // Botswana
  BR = 'BR', // Brésil
  BN = 'BN', // Brunéi Darussalam
  BG = 'BG', // Bulgarie
  BF = 'BF', // Burkina Faso
  BI = 'BI', // Burundi
  KH = 'KH', // Cambodge
  CM = 'CM', // Cameroun
  CA = 'CA', // Canada
  CV = 'CV', // Cap-Vert
  CL = 'CL', // Chili
  CN = 'CN', // Chine
  CY = 'CY', // Chypre
  CO = 'CO', // Colombie
  KM = 'KM', // Comores
  KP = 'KP', // Corée du Nord
  KR = 'KR', // Corée du Sud
  CR = 'CR', // Costa Rica
  CI = 'CI', // Côte d'Ivoire
  HR = 'HR', // Croatie
  CU = 'CU', // Cuba
  CW = 'CW', // Curaçao
  DK = 'DK', // Danemark
  DJ = 'DJ', // Djibouti
  DM = 'DM', // Dominique
  EG = 'EG', // Égypte
  SV = 'SV', // El Salvador
  AE = 'AE', // Émirats arabes unis
  EC = 'EC', // Équateur
  ER = 'ER', // Érythrée
  ES = 'ES', // Espagne
  EE = 'EE', // Estonie
  SZ = 'SZ', // Eswatini
  US = 'US', // États-Unis
  ET = 'ET', // Éthiopie
  FJ = 'FJ', // Fidji
  FI = 'FI', // Finlande
  FR = 'FR', // France
  fr = 'fr', // France
  GA = 'GA', // Gabon
  GM = 'GM', // Gambie
  GE = 'GE', // Géorgie
  GS = 'GS', // Géorgie du Sud et les Îles Sandwich du Sud
  GH = 'GH', // Ghana
  GI = 'GI', // Gibraltar
  GR = 'GR', // Grèce
  GD = 'GD', // Grenade
  GL = 'GL', // Groenland
  GP = 'GP', // Guadeloupe
  GU = 'GU', // Guam
  GT = 'GT', // Guatemala
  GG = 'GG', // Guernesey
  GN = 'GN', // Guinée
  GW = 'GW', // Guinée-Bissau
  GQ = 'GQ', // Guinée équatoriale
  GY = 'GY', // Guyana
  GF = 'GF', // Guyane française
  HT = 'HT', // Haïti
  HN = 'HN', // Honduras
  HK = 'HK', // Hong Kong
  HU = 'HU', // Hongrie
  BV = 'BV', // Île Bouvet
  CX = 'CX', // Île Christmas
  IM = 'IM', // Île de Man
  NF = 'NF', // Île Norfolk
  KY = 'KY', // Îles Caïmans
  CC = 'CC', // Îles Cocos (Keeling)
  CK = 'CK', // Îles Cook
  FK = 'FK', // Îles Falkland (Malvinas)
  FO = 'FO', // Îles Féroé
  HM = 'HM', // Îles Heard et McDonald
  MP = 'MP', // Îles Mariannes du Nord
  MH = 'MH', // Îles Marshall
  UM = 'UM', // Îles mineures éloignées des États-Unis
  PN = 'PN', // Îles Pitcairn
  SB = 'SB', // Îles Salomon
  TC = 'TC', // Îles Turks et Caïques
  VG = 'VG', // Îles Vierges britanniques
  VI = 'VI', // Îles Vierges des États-Unis
  IN = 'IN', // Inde
  ID = 'ID', // Indonésie
  IR = 'IR', // Iran
  IQ = 'IQ', // Iraq
  IE = 'IE', // Irlande
  IS = 'IS', // Islande
  IL = 'IL', // Israël
  IT = 'IT', // Italie
  JM = 'JM', // Jamaïque
  JP = 'JP', // Japon
  JE = 'JE', // Jersey
  JO = 'JO', // Jordanie
  KZ = 'KZ', // Kazakhstan
  KE = 'KE', // Kenya
  KG = 'KG', // Kirghizistan
  KI = 'KI', // Kiribati
  XK = 'XK', // Kosovo
  KW = 'KW', // Koweït
  RE = 'RE', // La Réunion
  LA = 'LA', // Laos
  LS = 'LS', // Lesotho
  LV = 'LV', // Lettonie
  LB = 'LB', // Liban
  LR = 'LR', // Liberia
  LY = 'LY', // Libye
  LI = 'LI', // Liechtenstein
  LT = 'LT', // Lituanie
  LU = 'LU', // Luxembourg
  MO = 'MO', // Macao
  MK = 'MK', // Macédoine du Nord
  MG = 'MG', // Madagascar
  MY = 'MY', // Malaisie
  MW = 'MW', // Malawi
  MV = 'MV', // Maldives
  ML = 'ML', // Mali
  MT = 'MT', // Malte
  MA = 'MA', // Maroc
  MQ = 'MQ', // Martinique
  MU = 'MU', // Maurice
  MR = 'MR', // Mauritanie
  YT = 'YT', // Mayotte
  MX = 'MX', // Mexique
  FM = 'FM', // Micronésie
  MD = 'MD', // Moldavie
  MC = 'MC', // Monaco
  MN = 'MN', // Mongolie
  ME = 'ME', // Monténégro
  MS = 'MS', // Montserrat
  MZ = 'MZ', // Mozambique
  MM = 'MM', // Myanmar (Birmanie)
  NA = 'NA', // Namibie
  CB = 'CB', // Nations caribéennes
  NR = 'NR', // Nauru
  NP = 'NP', // Népal
  NI = 'NI', // Nicaragua
  NE = 'NE', // Niger
  NG = 'NG', // Nigeria
  NU = 'NU', // Niué
  NO = 'NO', // Norvège
  NC = 'NC', // Nouvelle-Calédonie
  NZ = 'NZ', // Nouvelle-Zélande
  OM = 'OM', // Oman
  UG = 'UG', // Ouganda
  UZ = 'UZ', // Ouzbékistan
  PK = 'PK', // Pakistan
  PW = 'PW', // Palaos
  PS = 'PS', // Palestine
  PA = 'PA', // Panama
  PG = 'PG', // Papouasie-Nouvelle-Guinée
  PY = 'PY', // Paraguay
  NL = 'NL', // Pays-Bas
  BQ = 'BQ', // Pays-Bas caribéens
  PE = 'PE', // Pérou
  PH = 'PH', // Philippines
  PL = 'PL', // Pologne
  PF = 'PF', // Polynésie française
  PR = 'PR', // Porto Rico
  PT = 'PT', // Portugal
  QA = 'QA', // Qatar
  CF = 'CF', // République centrafricaine
  CD = 'CD', // République démocratique du Congo
  DO = 'DO', // République dominicaine
  CG = 'CG', // République du Congo
  RO = 'RO', // Roumanie
  GB = 'GB', // Royaume-Uni
  RU = 'RU', // Russie
  RW = 'RW', // Rwanda
  EH = 'EH', // Sahara occidental
  SH = 'SH', // Sainte-Hélène
  LC = 'LC', // Sainte-Lucie
  BL = 'BL', // Saint-Barthélemy
  KN = 'KN', // Saint-Kitts-et-Nevis
  SM = 'SM', // Saint-Marin
  MF = 'MF', // Saint-Martin
  PM = 'PM', // Saint-Pierre-et-Miquelon
  VC = 'VC', // Saint-Vincent et les Grenadines
  WS = 'WS', // Samoa
  AS = 'AS', // Samoa américaines
  ST = 'ST', // Sao Tomé-et-Principe
  SN = 'SN', // Sénégal
  RS = 'RS', // Serbie
  SC = 'SC', // Seychelles
  SL = 'SL', // Sierra Leone
  SG = 'SG', // Singapour
  SX = 'SX', // Sint Maarten
  SK = 'SK', // Slovaquie
  SI = 'SI', // Slovénie
  SO = 'SO', // Somalie
  SD = 'SD', // Soudan
  SS = 'SS', // Soudan du Sud
  LK = 'LK', // Sri Lanka
  SE = 'SE', // Suède
  CH = 'CH', // Suisse
  SR = 'SR', // Suriname
  SJ = 'SJ', // Svalbard et Jan Mayen
  SY = 'SY', // Syrie
  TJ = 'TJ', // Tadjikistan
  TW = 'TW', // Taïwan
  TZ = 'TZ', // Tanzanie
  TD = 'TD', // Tchad
  CZ = 'CZ', // Tchéquie
  IO = 'IO', // Territoire britannique de l'océan Indien
  TF = 'TF', // Terres australes et antarctiques françaises
  TH = 'TH', // Thaïlande
  TL = 'TL', // Timor-Leste
  TG = 'TG', // Togo
  TK = 'TK', // Tokelau
  TO = 'TO', // Tonga
  TT = 'TT', // Trinité-et-Tobago
  TN = 'TN', // Tunisie
  TM = 'TM', // Turkménistan
  TR = 'TR', // Turquie
  TV = 'TV', // Tuvalu
  UA = 'UA', // Ukraine
  UY = 'UY', // Uruguay
  VU = 'VU', // Vanuatu
  VA = 'VA', // Vatican
  VE = 'VE', // Venezuela
  VN = 'VN', // Vietnam
  WF = 'WF', // Wallis et Futuna
  YE = 'YE', // Yémen
  ZM = 'ZM', // Zambie
  ZW = 'ZW', // Zimbabwe
  OO = 'OO', // Autre
  PI = 'PI', // Pays à renseigner
}
